export default __webpack_public_path__ + "static/media/rubik-v12-latin-500.8a4a38b8.woff";